/* eslint-disable no-nested-ternary */
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Select,
} from 'antd';
import StockMasterActions from '@Actions/inventory/stockMasterActions';
import PRZSelect from '../../UI/PRZSelect';

/**
 *
 */
const SelectSkuList = ({
  selectedTenant, onChange, selectedList, getProductListLoading, productLists, getProductList, disabled,
}) => {

  useEffect(() => {
      getProductList({
        tenantId: selectedTenant,
        keyword: '',
        page: 1,
        limit: 100,
      });
  }, [selectedTenant]);

  return (
    <Fragment>
      <PRZSelect
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        value={selectedList}
        onChange={(value) => onChange(value)}
        showSearch
        loading={getProductListLoading}
        options={productLists?.sku_lists?.map((item) => ({
          key: item?.sku_list_id,
          value: item?.sku_list_id,
          label: item?.list_name,
        }))}
        disabled={disabled}
      />
    </Fragment>
  )
};

const mapStateToProps = ({ UserReducers, StockMasterReducers }) => ({
  user: UserReducers.user,
  productLists: StockMasterReducers.productLists,
  getProductListLoading: StockMasterReducers.getProductListLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getProductList: (payload, callback) => dispatch(StockMasterActions.getProductList(payload, callback)),
});

SelectSkuList.propTypes = {
  user: PropTypes.any,
  match: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectSkuList));
